import React from 'react';
import { ModalHeader, ModalBody, Button } from 'reactstrap';

import { closeEditNotificationModal } from '../../../redux/actions/alertModalActions';
import UseAsTemplate from '../../../components/TrekDetail/DayOverview/UseAsTemplateButton';
// import { closeModal } from '../../../redux/actions/modalAction';
import { openLoginModal } from '../../../redux/actions/authActions';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import makeUrl from '../../../lib/makeUrl';
import { closeServicesModal } from '../../../redux/actions/addToDayModalactions';

const EditNotifications = props => {
  const goToOverview = () => {
    const { id, name, region, history, toggleDayEditModal, toggleServicesModal } = props;
    return (
      <Button
        color="primary"
        onClick={() => {
          history.push(makeUrl.trekOverview(name, id, region));
          toggleDayEditModal();
          toggleServicesModal();
        }}
      >
        Go To Overview
      </Button>
    );
  };

  const goToLogin = () => {
    const { openLoginModal } = props;
    return (
      <Button color="primary" onClick={openLoginModal}>
        Login
      </Button>
    );
  };

  const renderMessage = {
    '1L-1T-0O': (
      <div>
        <p>
          You cannot edit Trek templates.
          <br /> If you wish to modify this trek, click on Use this Trek .
        </p>
        <UseAsTemplate />
      </div>
    ),
    '1L-0T-0O': (
      <div>
        <p>
          You do no have permission to edit this trek. <br /> Please go to Trek Overview
          Page and Contact the Owner or Join the trek for necessary permissions.
        </p>
        {goToOverview()}
      </div>
    ),
    '0L-0T': (
      <div>
        <p>
          You cannot edit treks without logging in. <br /> Please Login to continue.
        </p>
        {goToLogin()}
      </div>
    ),
    '0L-1T': (
      <div>
        <p>
          You cannot edit treks without logging in. <br />
          Please Login to continue.
        </p>
        {goToLogin()}
      </div>
    ),
  };

  const message = props.type && renderMessage[props.type];
  return (
    <div>
      <ModalHeader toggle={props.toggle} />
      <ModalBody>{message}</ModalBody>
    </div>
  );
};

const mapStateToProps = state => {
  const type = state.alertModal.notificationType;
  const name = state.selectedTrek.trek.name;
  const id = state.selectedTrek.trek.id;
  const region = state.selectedTrek.trek.region;
  return {
    type,
    name,
    id,
    region,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    toggleDayEditModal: () => {
      // dispatch(closeModal());
      dispatch(closeEditNotificationModal());
    },
    openLoginModal: () => {
      dispatch(openLoginModal());
      dispatch(closeEditNotificationModal());
    },
    toggleServicesModal: () => {
      dispatch(closeServicesModal());
    },
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(EditNotifications)
);



// WEBPACK FOOTER //
// ./src/screens/Trek/EditNotifications/EditNotifications.js